import './hevensSelect';
import './hevensSelect.scss';

export default function customSelect(el) {
  $(el).hevensSelect({ disable_search: true });
  return {
    destroy() {
      $(el).hevensSelect('destroy');
    },
  };
}



// WEBPACK FOOTER //
// ./components/customSelect/customSelect.js